import { render } from "./FormTextLabel.vue?vue&type=template&id=249edd81"
import script from "./FormTextLabel.vue?vue&type=script&lang=js"
export * from "./FormTextLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__